import React from "react";
import styled from "styled-components";
import { renderChatListTimestamp } from "src/utils/dates";
import { StyledText } from "src/scenes/Chat/components/styled/shared";

const Timestamp = styled(StyledText)`
    flex-shrink: 0;
    white-space: nowrap;
`;

const ListDate = (props) => {
    const { timestamp } = props;

    return (
        <Timestamp size="0.8125rem" weight="500" color="#7B8793" width="auto">
            { timestamp ? renderChatListTimestamp(timestamp) : "" }
        </Timestamp>
    );
};

export default ListDate;
